<div
  [innerHTML]="htmlContent"
  [style.width.px]="getScaledWidth()"
  [style.height.px]="getScaledHeight()"
></div>
